/* Milagron · renk adı → arka plan (renk listesi + bileşik adlar + desenler) */
var MGC_PAT = { 'çizgili': 'cizgili', 'cizgili': 'cizgili', 'puantiye': 'puantiye', 'puantiyeli': 'puantiye', 'benekli': 'puantiye', 'desenli': 'desen', 'desen': 'desen', 'ekose': 'ekose', 'ekoseli': 'ekose', 'kareli': 'ekose', 'leopar': 'leopar', 'zebra': 'zebra', 'kamuflaj': 'kamuflaj', 'çiçek': 'cicek', 'çiçekli': 'cicek', 'çok renkli': 'cok', 'renkli': 'cok', 'multi': 'cok', 'multicolor': 'cok', 'hologram': 'cok', 'patchwork': 'cok' };
function mgcNorm(s) { return String(s || '').toLocaleLowerCase('tr-TR').replace(/\s+/g, ' ').trim(); }
function mgcResolve(name, map) {
  var k = mgcNorm(name), v = map[k];
  if (v) return v;
  var hex = [], pat = '';
  k.split(/\s*[\/&,+]\s*|\s+-\s+|\s+ve\s+/).filter(Boolean).forEach(function (p) {
    if (MGC_PAT[p]) { pat = pat || MGC_PAT[p]; return; }
    var x = map[p];
    if (!x) {
      var w = p.split(' ');
      w.forEach(function (t) { if (MGC_PAT[t]) pat = pat || MGC_PAT[t]; });
      var base = w.filter(function (t) { return !MGC_PAT[t]; });
      x = map[base.join(' ')];
      for (var n = base.length - 1; !x && n > 0; n--) {
        for (var s = 0; s + n <= base.length && !x; s++) x = map[base.slice(s, s + n).join(' ')];
      }
    }
    if (x) {
      var h = x.match(/#[0-9a-f]{3,8}/gi); if (h) hex = hex.concat(h);
      var d = /desen:([a-zçğıöşü]+)/i.exec(x); if (d) pat = pat || d[1];
    }
  });
  if (!hex.length && !pat) return '';
  return hex.join('') + (pat ? 'desen:' + pat : '');
}
function mgcLight(h) {
  h = h.replace('#', ''); if (h.length === 3) h = h.replace(/(.)/g, '$1$1');
  var r = parseInt(h.substr(0, 2), 16), g = parseInt(h.substr(2, 2), 16), b = parseInt(h.substr(4, 2), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 > 150;
}
function mgcBg(v) {
  if (!v) return '';
  v = String(v).replace(/desen:/g, ' desen:');
  var h = v.match(/#[0-9a-f]{3,8}/gi) || [];
  var d = (/desen:([a-zçğıöşü]+)/i.exec(v) || [])[1] || '';
  if (/^(cok|desen|cicek)$/.test(d) && h.length < 2) h = ['#e4572e', '#f2c230', '#3fa34d', '#2f6bd8'];
  if (d === 'cok' && h.length < 4) h = ['#e4572e', '#f2c230', '#3fa34d', '#2f6bd8'];
  var base = h[0] || '#ffffff', alt = h[1] || (mgcLight(base) ? '#1f2a44' : '#ffffff');
  if (d === 'puantiye') return 'radial-gradient(circle, ' + alt + ' 24%, transparent 28%) 0 0/7px 7px, ' + base;
  if (d === 'cizgili') return 'repeating-linear-gradient(135deg, ' + base + ' 0 3px, ' + alt + ' 3px 5px)';
  if (d === 'zebra') return 'repeating-linear-gradient(135deg, #f7f6f2 0 3px, #1a1a1a 3px 6px)';
  if (d === 'leopar') return 'radial-gradient(circle, #3b2a1a 26%, transparent 32%) 0 0/7px 7px, radial-gradient(circle, #3b2a1a 20%, transparent 26%) 3.5px 3.5px/7px 7px, #c8a165';
  if (d === 'ekose') return 'repeating-linear-gradient(0deg, rgba(0,0,0,.28) 0 2px, transparent 2px 6px), repeating-linear-gradient(90deg, rgba(0,0,0,.28) 0 2px, transparent 2px 6px), ' + (h[0] || '#b5302c');
  if (d === 'kamuflaj') return 'radial-gradient(circle at 30% 30%, #5b6b2c 30%, transparent 32%), radial-gradient(circle at 70% 65%, #3b3d2a 28%, transparent 30%), #8a7a5c';
  if (!h.length) return /^https?:|^\/\//.test(v) ? 'center/cover url("' + v + '")' : '';
  if (h.length === 1) return h[0];
  var st = 100 / h.length, parts = h.map(function (x, i) { return x + ' ' + (i * st) + '% ' + ((i + 1) * st) + '%'; });
  if (h.length >= 4) return 'conic-gradient(' + parts.join(',') + ')';
  return 'linear-gradient(135deg,' + parts.join(',') + ')';
}

/* =========================================================================
   Milagron · Mobil filtre (iki sütun) ve sıralama (çubuğun altından açılır)
   - Filtre: soldaki sütunda başlıklar ve seçim sayısı, sağda seçili başlığın
     seçenekleri. Altta "Temizle" ve "N Ürünü Gör". Temanın kendi formu ve
     inputları aynen kullanılır; filtreler yine tema tarafından uygulanır.
   - Sıralama: temanın açılır listesi tam genişlikte, çubuğun hemen altında,
     büyük satırlar; az kullanılan seçenekler gizli.
   Tema filtre alanını her değişiklikte yeniden çizer; MutationObserver ile
   düzen tekrar kurulur.
   ========================================================================= */
(function () {
  'use strict';
  if (window.__mgF2) return;
  window.__mgF2 = true;

  var MQ = window.matchMedia('(max-width: 767.98px)');
  var ACTIVE = null;

  function txt(e) { return e ? e.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function head(g) { return txt(g.querySelector('.filter-group__heading__text')); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function groupsOf(form) {
    return [].slice.call(form.children).filter(function (g) {
      return g.classList && g.classList.contains('filter-group') &&
        !g.classList.contains('filter-group--availability') &&
        !g.classList.contains('filter-group--applied') &&
        !g.querySelector('input[name="sort_by"]') && head(g) && !solo(g);
    });
  }
  // Tek seçeneği olan (tüm ürünlerde aynı olan) başlık filtrede gösterilmez; seçiliyse kalır
  function solo(g) {
    if (g.querySelector('.cc-price-range__input')) return false;
    var opts = g.querySelectorAll('input[type=checkbox]:not(:disabled), input[type=radio]:not(:disabled)');
    return opts.length <= 1 && !g.querySelector('input:checked');
  }
  function countOf(g) {
    var n = g.querySelectorAll('input[type=checkbox]:checked, input[type=radio]:checked').length;
    if (!n) {
      var pr = g.querySelectorAll('.cc-price-range__input');
      for (var k = 0; k < pr.length; k++) if (pr[k].value) { n = 1; break; }
    }
    return n;
  }

  // ---- Renk adları → renk (Tema ayarları > Swatches listesi)
  var SWM = null;
  function swMap() {
    if (SWM) return SWM;
    SWM = {};
    String(window.MG_SW || '').split(/\r?\n/).forEach(function (line) {
      var i = line.indexOf(':');
      if (i < 1) return;
      var k = line.slice(0, i).toLocaleLowerCase('tr-TR').trim();
      if (k && !(k in SWM)) SWM[k] = line.slice(i + 1).trim();
    });
    return SWM;
  }
  function swBg(v) {
    var c = v && v.match(/#[0-9a-f]{3,8}/gi);
    if (!c) return '';
    if (c.length === 1) return c[0];
    var s = 100 / c.length;
    if (c.length >= 4) return 'conic-gradient(' + c.map(function (x, k) { return x + ' ' + k * s + '% ' + (k + 1) * s + '%'; }).join(',') + ')';
    return 'linear-gradient(135deg,' + c.map(function (x, k) { return x + ' ' + k * s + '% ' + (k + 1) * s + '%'; }).join(',') + ')';
  }
  function paintColors(g) {
    if (!/^(renk|color|colour)$/i.test(head(g))) return;
    g.classList.add('mg-f2-renk');
    g.querySelectorAll('label').forEach(function (l) {
      if (l.querySelector('.mg-fsw')) return;
      var t = l.querySelector('.filter-group__item__text');
      if (!t) return;
      var bg = mgcBg(mgcResolve(txt(t), swMap()));
      var i = document.createElement('i');
      i.className = 'mg-fsw';
      if (bg) i.style.background = bg;
      t.insertBefore(i, t.firstChild);
    });
  }

  function countText() {
    var c = document.querySelector('.utility-bar__centre .utility-bar__item');
    var m = c && /(\d[\d.]*)/.exec(txt(c));
    return m ? m[1] + ' Ürünü Gör' : 'Ürünleri Gör';
  }

  function avSwitch() {
    document.querySelectorAll('.filter-group--availability .filter-toggle--inline').forEach(function (t) {
      var hide = t.querySelector('input.filter-toggle__input[value="1"]');
      var show = t.querySelector('input.filter-toggle__input[value=""]');
      if (!hide || !show) return;
      var sw = t.querySelector('.mg-av-sw');
      if (!sw) {
        var l = t.querySelector('.filter-toggle__group-label');
        if (l) l.innerHTML = 'Stoktakiler<small>Tükenen ürünleri gizle</small>';
        sw = document.createElement('button');
        sw.type = 'button'; sw.className = 'mg-av-sw'; sw.setAttribute('role', 'switch');
        sw.setAttribute('aria-label', 'Sadece stoktaki ürünleri göster');
        sw.innerHTML = '<i></i>';
        t.appendChild(sw);
        t.classList.add('mg-av');
        t.addEventListener('click', function (e) {
          if (e.target.closest('label')) return;
          e.preventDefault();
          var tgt = hide.checked ? show : hide;
          tgt.checked = true;
          tgt.dispatchEvent(new Event('change', { bubbles: true }));
          sw.setAttribute('aria-checked', String(hide.checked));
        });
      }
      sw.setAttribute('aria-checked', String(hide.checked));
    });
  }
  function build() {
    avSwitch();
    var f = document.querySelector('.filters');
    if (!f) return;
    if (!MQ.matches) { f.classList.remove('mg-f2'); return; }
    var form = f.querySelector('#CollectionFilterForm');
    if (!form) return;
    var gs = groupsOf(form);
    if (!gs.length) return;
    f.classList.add('mg-f2');

    var names = gs.map(head);
    if (!ACTIVE || names.indexOf(ACTIVE) < 0) {
      var withSel = gs.filter(function (g) { return countOf(g) > 0; })[0];
      ACTIVE = head(withSel || gs[0]);
    }

    var nav = form.querySelector(':scope > .mg-f2-nav');
    if (!nav) {
      nav = document.createElement('div');
      nav.className = 'mg-f2-nav';
      nav.setAttribute('role', 'tablist');
      var av = form.querySelector(':scope > .filter-group--availability');
      form.insertBefore(nav, av ? av.nextSibling : form.firstChild);
    }
    var html = gs.map(function (g) {
      var h = head(g), n = countOf(g);
      return '<button type="button" role="tab" class="mg-f2-tab' + (h === ACTIVE ? ' is-on' : '') + '" data-mg-tab="' + esc(h) + '" aria-selected="' + (h === ACTIVE) + '">' +
        '<span>' + esc(h) + '</span>' + (n ? '<b class="mg-f2-cnt">' + n + '</b>' : '') + '</button>';
    }).join('');
    if (nav.innerHTML !== html) nav.innerHTML = html;

    [].slice.call(form.children).forEach(function (g) {
      if (!g.classList || !g.classList.contains('filter-group') || g.classList.contains('filter-group--availability')) return;
      var on = gs.indexOf(g) > -1 && head(g) === ACTIVE;
      if (g.classList.contains('mg-f2-on') !== on) g.classList.toggle('mg-f2-on', on);
      if (gs.indexOf(g) < 0 && !g.classList.contains('mg-f2-off')) g.classList.add('mg-f2-off');
    });
    gs.forEach(paintColors);

    var ft = f.querySelector(':scope > .mg-f2-ft');
    if (!ft) {
      ft = document.createElement('div');
      ft.className = 'mg-f2-ft';
      ft.innerHTML = '<button type="button" class="mg-f2-clear">Temizle</button><button type="button" class="mg-f2-see"></button>';
      f.appendChild(ft);
    }
    var see = ft.querySelector('.mg-f2-see'), ct = countText();
    if (see.textContent !== ct) see.textContent = ct;
    var clr = f.querySelector('.filter-group__clear-link');
    var dis = !clr;
    if (ft.querySelector('.mg-f2-clear').disabled !== dis) ft.querySelector('.mg-f2-clear').disabled = dis;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.mg-f2-tab');
    if (t) {
      e.preventDefault();
      ACTIVE = t.getAttribute('data-mg-tab');
      build();
      var on = document.querySelector('.filters .mg-f2-on');
      if (on) on.scrollTop = 0;
      return;
    }
    if (e.target.closest && e.target.closest('.mg-f2-see')) {
      e.preventDefault();
      var x = document.querySelector('.filters .filters__close');
      if (x) x.click();
      return;
    }
    if (e.target.closest && e.target.closest('.mg-f2-clear')) {
      e.preventDefault();
      var c = document.querySelector('.filters .filter-group__clear-link');
      if (c) c.click();
    }
  });

  // ---- Sıralama
  var SORT_NAME = {
    'manual': 'Önerilen',
    'best-selling': 'Çok satanlar',
    'most-relevant': 'En alakalı',
    'created-descending': 'Yeni gelenler',
    'created-ascending': 'Tarih: Eskiden yeniye',
    'price-ascending': 'Fiyat: Düşükten yükseğe',
    'price-descending': 'Fiyat: Yüksekten düşüğe',
    'title-ascending': 'Alfabetik: A-Z',
    'title-descending': 'Alfabetik: Z-A'
  };
  var DISC_LABEL = 'En yüksek indirim';
  var CS = { indirim: { cls: 'mg-s-disc', label: DISC_LABEL, btn: 'En yüksek indirim' },
             yeni: { cls: 'mg-s-new', label: 'Yeni gelenler', btn: 'Yeni gelenler', only: 'template-search' } };
  var csMode = (/[?&]mg_sort=(indirim|yeni)(&|$)/.exec(location.search) || [])[1] || '';
  var discOn = !!csMode;
  function sortSetup() {
    var dd = document.querySelector('.utility-bar__sort link-dropdown');
    if (!dd) return;
    var opts = dd.querySelector('.link-dropdown__options');
    dd.querySelectorAll('.link-dropdown__link').forEach(function (a) {
      var m = /sort_by=([a-z-]+)/.exec(a.getAttribute('href') || '');
      if (m && SORT_NAME[m[1]] && txt(a) !== SORT_NAME[m[1]]) a.textContent = SORT_NAME[m[1]];
    });
    Object.keys(CS).forEach(function (k) {
      var c = CS[k];
      if (!opts || (c.only && !document.body.classList.contains(c.only))) return;
      if (!opts.querySelector('.' + c.cls)) {
        var a = document.createElement('a');
        a.className = 'link-dropdown__link mg-cs ' + c.cls;
        a.href = '#' + k;
        a.setAttribute('data-mg-cs', k);
        a.textContent = c.label;
        if (k === 'yeni') opts.insertBefore(a, opts.firstChild); else opts.appendChild(a);
      }
    });
    // Az kullanılan / koleksiyonda anlamsız seçenekler gizli (seçiliyse kalır); masaüstünde sıra:
    // Önerilen, Yeni gelenler, Çok satanlar, En yüksek indirim, Fiyat düşükten / yüksekten
    var ORD = { 'manual': 0, 'relevance': 0, 'created-descending': 1, 'best-selling': 2, 'price-ascending': 4, 'price-descending': 5 };
    dd.querySelectorAll('.link-dropdown__link').forEach(function (a) {
      var m = /sort_by=([a-z-]+)/.exec(a.getAttribute('href') || ''), k = m ? m[1] : '';
      var hide = /^(title-ascending|title-descending|created-ascending|most-relevant)$/.test(k) && !a.classList.contains('link-dropdown__link--active');
      if ((a.style.display === 'none') !== hide) a.style.display = hide ? 'none' : '';
      var o = a.classList.contains('mg-s-new') ? 1 : a.classList.contains('mg-s-disc') ? 3 : (k in ORD ? ORD[k] : 9);
      var want = MQ.matches ? '' : String(o);
      if (a.style.order !== want) a.style.order = want;
    });
    var dl = csMode && opts && opts.querySelector('.' + CS[csMode].cls);
    if (discOn && dl) {
      dd.querySelectorAll('.link-dropdown__link--active').forEach(function (a) { if (a !== dl) a.classList.remove('link-dropdown__link--active'); });
      if (!dl.classList.contains('link-dropdown__link--active')) dl.classList.add('link-dropdown__link--active');
    }
    var act = dd.querySelector('.link-dropdown__link--active');
    var bt = dd.querySelector('.link-dropdown__button-text');
    var lbl = act ? (act.getAttribute('data-mg-cs') ? CS[act.getAttribute('data-mg-cs')].btn : txt(act)) : '';
    if (act && bt && txt(bt) !== lbl) bt.textContent = lbl;
    var btn = dd.querySelector('.link-dropdown__button');
    if (btn && !btn._mgSort) {
      btn._mgSort = true;
      var sync = function () {
        var open = btn.getAttribute('aria-expanded') === 'true' && MQ.matches;
        document.body.classList.toggle('mg-sort-open', open);
        if (open) place();
      };
      new MutationObserver(sync).observe(btn, { attributes: true, attributeFilter: ['aria-expanded'] });
      sync();
    }
    if (discOn) applyDiscount();
  }

  // ---- İndirim oranına göre sıralama: koleksiyonun (filtreli) sayfaları çekilir,
  // her ürünün toplam indirimi (eski fiyat → sepette fiyatı) hesaplanır, büyükten küçüğe dizilir.
  var MAXPAGES = 20;
  function money(el) {
    var m = el && /(\d{1,3}(?:\.\d{3})*|\d+),(\d{2})/.exec(el.textContent);
    return m ? parseFloat(m[1].replace(/\./g, '') + '.' + m[2]) : 0;
  }
  function discOf(pb) {
    var cur = money(pb.querySelector('.price__current'));
    var was = money(pb.querySelector('.price__was')) || cur;
    var eff = cur, rot = pb.querySelector('[data-efx-tags]');
    if (rot) {
      var m = /Sepette\s*%\s*(\d+(?:[.,]\d+)?)/i.exec(rot.getAttribute('data-efx-tags') || '');
      if (m) eff = cur * (1 - parseFloat(m[1].replace(',', '.')) / 100);
    }
    return was > 0 ? (was - eff) / was : 0;
  }
  var discBusy = false, discKey = '', opts0;
  function pageUrl(n) {
    var u = new URL(location.href);
    u.searchParams.delete('mg_sort');
    u.searchParams.delete('page');
    u.searchParams.delete('sort_by');
    if (n > 1) u.searchParams.set('page', n);
    return u.toString();
  }
  function applyDiscount() {
    var grid = document.querySelector('.product-grid--coll') || document.querySelector('.collection-listing .product-grid');
    if (!grid || discBusy) return;
    var key = pageUrl(1) + '|' + csMode;
    if (grid.dataset.mgDisc === key) return;
    discBusy = true;
    grid.classList.add('mg-disc-loading');
    var pag = document.querySelector('.pagination-row');
    var last = 1;
    if (pag) pag.querySelectorAll('.pagination__link').forEach(function (a) {
      var m = /[?&]page=(\d+)/.exec(a.getAttribute('href') || '');
      if (m) last = Math.max(last, +m[1]);
    });
    last = Math.min(last, MAXPAGES);
    var pages = [];
    for (var n = 1; n <= last; n++) pages.push(n);
    var results = {};
    var next = 0;
    function worker() {
      if (next >= pages.length) return Promise.resolve();
      var n = pages[next++];
      return fetch(pageUrl(n), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) {
        var doc = new DOMParser().parseFromString(h, 'text/html');
        var g = doc.querySelector('.product-grid--coll') || doc.querySelector('.collection-listing .product-grid');
        results[n] = g ? [].slice.call(g.children) : [];
      }).catch(function () { results[n] = []; }).then(worker);
    }
    Promise.all([worker(), worker(), worker(), worker()]).then(function () {
      var items = [], seen = {};
      pages.forEach(function (n) {
        (results[n] || []).forEach(function (el, i) {
          var pb = el.matches('product-block') ? el : el.querySelector('product-block');
          var id = pb && pb.getAttribute('data-product-id');
          if (id && seen[id]) return;
          if (id) seen[id] = 1;
          items.push({ el: el, d: pb ? (csMode === 'yeni' ? +(pb.getAttribute('data-mg-pub') || 0) : discOf(pb)) : 0, o: items.length });
        });
      });
      items.sort(function (a, b) { return (b.d - a.d) || (a.o - b.o); });
      var frag = document.createDocumentFragment();
      items.forEach(function (it) { frag.appendChild(document.importNode(it.el, true)); });
      grid.innerHTML = '';
      grid.appendChild(frag);
      grid.dataset.mgDisc = key;
      if (pag) pag.style.display = 'none';
      grid.classList.remove('mg-disc-loading');
      discBusy = false;
      window.dispatchEvent(new Event('resize'));
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.mg-cs');
    if (a) {
      e.preventDefault();
      e.stopPropagation();
      discOn = true;
      csMode = a.getAttribute('data-mg-cs');
      var u = new URL(location.href);
      u.searchParams.set('mg_sort', csMode);
      u.searchParams.delete('page');
      history.replaceState(history.state, '', u.toString());
      var btn = document.querySelector('.utility-bar__sort .link-dropdown__button');
      if (btn && btn.getAttribute('aria-expanded') === 'true') btn.click();
      var g = document.querySelector('.product-grid--coll');
      if (g) delete g.dataset.mgDisc;
      opts0 = document.querySelectorAll('.utility-bar__sort .link-dropdown__link--active');
      opts0.forEach(function (x) { if (x !== a) x.classList.remove('link-dropdown__link--active'); });
      sortSetup();
      return;
    }
    // Başka bir sıralama seçilirse indirim sıralaması biter (tema linki zaten sayfayı yeniler)
    if (e.target.closest && e.target.closest('.utility-bar__sort .link-dropdown__link:not(.mg-cs)')) { discOn = false; csMode = ''; }
  }, true);
  function place() {
    var bar = document.querySelector('.utility-bar');
    if (!bar) return;
    var b = Math.max(0, Math.round(bar.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty('--mg-sort-top', b + 'px');
  }
  window.addEventListener('scroll', function () { if (document.body.classList.contains('mg-sort-open')) place(); }, { passive: true });
  // Arka plana dokununca liste kapansın
  document.addEventListener('click', function (e) {
    if (!document.body.classList.contains('mg-sort-open')) return;
    if (e.target.closest && e.target.closest('.utility-bar__sort')) return;
    var btn = document.querySelector('.utility-bar__sort .link-dropdown__button');
    if (btn && btn.getAttribute('aria-expanded') === 'true') {
      // Karartılmış alana dokunuş arkadaki ürünü açmasın, sadece listeyi kapatsın
      e.preventDefault();
      e.stopPropagation();
      btn.click();
    }
  }, true);

  var t;
  function run() { clearTimeout(t); t = setTimeout(function () { build(); sortSetup(); }, 30); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  if (MQ.addEventListener) MQ.addEventListener('change', run);
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var tg = ms[i].target;
      if (tg.closest && (tg.closest('.filters') || tg.closest('.utility-bar') || tg.querySelector && tg.querySelector('.filters, .utility-bar'))) {
        if (tg.closest('.mg-f2-nav') || tg.closest('.mg-f2-ft')) continue;
        run(); return;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();

/* Milagron: filtre paneli açıkken arka sayfa kaymasın (iOS'ta alt çubuk küçülüp panelin altında boşluk açılmasın) */
;(function(){
  var MQ = window.matchMedia('(max-width:767.98px)');
  var locked = false, y = 0;
  function isOpen(){ var f=document.querySelector('.filters.mg-f2'); if(!f) return false; var r=f.getBoundingClientRect(); return r.width>0 && r.right>window.innerWidth*0.6 && r.left>-10 && getComputedStyle(f).visibility!=='hidden'; }
  function lock(){ if(locked) return; locked=true; y=window.scrollY; var b=document.body.style; b.position='fixed'; b.top=(-y)+'px'; b.left='0'; b.right='0'; b.width='100%'; document.documentElement.classList.add('mg-filters-open'); }
  function unlock(){ if(!locked) return; locked=false; var b=document.body.style; b.position=''; b.top=''; b.left=''; b.right=''; b.width=''; document.documentElement.classList.remove('mg-filters-open'); window.scrollTo(0,y); }
  function check(){ if(!MQ.matches) return; if(isOpen()) lock(); else unlock(); }
  function soon(){ [60,350,700].forEach(function(t){ setTimeout(check,t); }); }
  document.addEventListener('click', soon, true);
  document.addEventListener('transitionend', function(e){ if(e.target && e.target.classList && e.target.classList.contains('filters')) check(); }, true);
  window.addEventListener('popstate', soon);
})();
